export const  GET_PARTICIPANTS_REQUEST='groupParticipantsReducer/GET_PARTICIPANTS_REQUEST';
export const  GET_PARTICIPANTS_SUCCESS='groupParticipantsReducer/GET_PARTICIPANTS_SUCCESS';
export const  GET_PARTICIPANTS_FAILED='groupParticipantsReducer/GET_PARTICIPANTS_FAILED';
